import LoginLink from '@components/LoginLink';
import { SSO_PROVIDERS } from '@constants';
import useAuth from '@contexts/AuthProvider';
import { useRegisterContext } from '@contexts/RegisterProvider';
import { Box, Button, Divider, IconButton, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export default function AuthMethodSelection() {
  const { login } = useAuth();
  const { registrationCode } = useRegisterContext();
  const { t, i18n } = useTranslation();

  const handleRegister = () => {
    if (!registrationCode) return;
    const redirectUri = new URL('/oauth', window.location.origin);
    redirectUri.searchParams.set('registrationCode', registrationCode);
    void login({ action: 'register', locale: i18n.resolvedLanguage, redirectUri: redirectUri.toString() });
  };

  return (
    <>
      <Typography sx={{ textAlign: 'center' }}>
        <Trans i18nKey="registration.choosePreferredMethod" />
      </Typography>
      <Stack sx={{ gap: 4, width: '100%' }}>
        <Button onClick={handleRegister} role="link" data-test-id="button-register-account">
          <Trans i18nKey="registration.actions.register" />
        </Button>
        {SSO_PROVIDERS.length > 0 && (
          <>
            <Divider>
              <Typography>
                <Trans i18nKey="registration.dividerLabel" />
              </Typography>
            </Divider>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', width: '100%' }}>
              {SSO_PROVIDERS.map(ssoProvider => (
                <IconButton
                  key={ssoProvider}
                  sx={{ flex: 1 }}
                  onClick={() => void login({ idpHint: ssoProvider, locale: i18n.resolvedLanguage })}
                  aria-label={t(`accessibility.signIn${ssoProvider.charAt(0).toUpperCase() + ssoProvider.slice(1)}`)}
                  role="link"
                  data-test-id={`button-login-${ssoProvider}`}
                >
                  <img src={`/icons/sso/${ssoProvider}.svg`} alt="" width={18} height={18} />
                </IconButton>
              ))}
            </Box>
          </>
        )}
        <LoginLink />
      </Stack>
    </>
  );
}
